import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      {/* Minimal Header */}
      <header className="sticky top-0 z-50 border-b border-border/50 bg-background">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img
              src="/assets/buttonup-logo.png"
              alt="Button Up Media"
              className="h-7 w-auto"
            />
            <span className="text-sm font-medium tracking-wide">DIGITAL AUDIT</span>
          </Link>

          <nav className="flex items-center gap-6 text-sm">
            <Link
              to="/web-audit"
              className={`transition-colors ${
                location.pathname === '/web-audit' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Web Audit
            </Link>
            <Link
              to="/compare"
              className={`transition-colors ${
                location.pathname === '/compare' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Compare
            </Link>
            <Link
              to="/"
              className={`transition-colors ${
                location.pathname === '/' || location.pathname === '/sem' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              SEM
            </Link>
            <Link
              to="/seo"
              className={`transition-colors ${
                location.pathname === '/seo' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              SEO
            </Link>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-6">{children}</main>

      {/* Minimal Footer */}
      <footer className="border-t border-border/50 mt-20">
        <div className="max-w-6xl mx-auto px-6 py-6 text-xs text-muted-foreground">
          Generated by Digital Audit Tool
        </div>
      </footer>
    </div>
  );
}
